import 'whatwg-fetch';
import config from '../../config/config';

const {
    API_WIDGETS_URL
} = config;

export const widgetsApi = {
    fetchList: async () => {
        const response = await fetch(
           `${API_WIDGETS_URL}`
        )

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        return {
            data: data,
            total: data.length,
        }
    }
}